// @ts-nocheck
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { apiCreatePpvSpecificV2, apiEditPpvSpecificV2 } from "../../../api/ppvApi";
import colors from "../../../styles/colors";

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

const ModalDialog = styled.div`
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: 28px auto;
    pointer-events: none;
`;

const ModalContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: ${colors.bgColorBlack2};
    color: white;
    background-clip: padding-box;
    border: 5px solid gold;
    border-radius: 5px;
    outline: 0;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    max-height: ${props => props.isDropdownOpen ? '98vh' : '95vh'};
    overflow-y: auto;
    transition: max-height 0.2s ease-in-out;
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 16px;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    gap: 12px;
`;

const ModalHeaderTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const ModalTitle = styled.h5`
    margin: 0;
    line-height: 1.5;
    font-size: 20px;
    font-weight: 500;
    color: gold;
`;

const CloseButton = styled.button`
    box-sizing: content-box;
    width: 1em;
    height: 1em;
    padding: 4px;
    color: white;
    border: 0;
    border-radius: 4px;
    opacity: 0.5;
    background: transparent;
    cursor: pointer;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
    text-shadow: 0 1px 0 #fff;
    
    &:hover {
        opacity: 0.75;
    }
    
    &:before {
        content: "×";
    }
`;

const ModalBody = styled.div`
    position: relative;
    flex: 1 1 auto;
    padding: 16px;
`;

const ModalFooter = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-shrink: 0;
    align-items: center;
    justify-content: flex-end;
    padding: 12px;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    gap: 8px;
`;

const FormGroup = styled.div`
    margin-bottom: ${props => props.mb || '16px'};
`;

const FormLabel = styled.label`
    display: inline-block;
    margin-bottom: 8px;
    font-weight: 500;
    color: gold;
    font-size: 18px;
`;

const FormInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
    
    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const FormTextarea = styled.textarea`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    resize: vertical;
    min-height: 60px;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
    
    &:disabled {
        background-color: #e9ecef;
        opacity: 1;
    }
`;

const Button = styled.button`
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #ffffff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 16px;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`;

const ButtonPrimary = styled(Button)`
    color: white;
    background-color: #0d6efd;
    border-color: #0d6efd;
    
    &:hover:not(:disabled) {
        color: white;
        background-color: #0b5ed7;
        border-color: #0a58ca;
    }
    
    &:focus {
        color: #ffffff;
        background-color: #0b5ed7;
        border-color: #0a58ca;
        box-shadow: 0 0 0 4px rgba(49, 132, 253, 0.5);
    }
`;

const ButtonSecondary = styled(Button)`
    color: #ffffff;
    background-color: #6c757d;
    border-color: #6c757d;
    
    &:hover:not(:disabled) {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
    }
    
    &:focus {
        color: #ffffff;
        background-color: #5c636a;
        border-color: #565e64;
        box-shadow: 0 0 0 4px rgba(130, 138, 145, 0.5);
    }
`;

const ErrorText = styled.p`
    margin-top: 4px;
    margin-bottom: 0;
    color: #dc3545;
    font-size: 14px;
`;

const StatusMessage = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #000000;
`;

const SuccessText = styled.div`
    text-align: right;
    padding: 0 16px;
    margin-top: 8px;
    color: #198754;
`;

const FileInfoText = styled.p`
    margin-top: 8px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    font-style: italic;
`;

const FileSelectedText = styled.p`
    margin-top: 8px;
    font-size: 14px;
    color: #198754;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &::before {
        content: "✓";
        color: #198754;
        font-weight: bold;
    }
`;

const FileSelectedContainer = styled.div`
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;

const RemoveFileButton = styled.button`
    padding: 4px 12px;
    font-size: 12px;
    background-color: #dc3545;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s ease-in-out;
    
    &:hover {
        background-color: #c82333;
    }
    
    &:active {
        transform: scale(0.98);
    }
`;

const DateInputContainer = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
`;

const DateToggleButton = styled.button`
    padding: 6px 12px;
    font-size: 14px;
    background-color: ${colors.bgColorBordeaux};
    color: white;
    border: 1px solid gold;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: background-color 0.2s ease-in-out;
    
    &:hover {
        background-color: ${colors.bgColorRed};
    }
`;

const DropdownContainer = styled.div`
    position: relative;
    width: 100%;
`;

const DropdownInput = styled.input`
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: #000000;
    background-color: #ffffff;
    background-image: none;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    
    &:focus {
        color: #000000;
        background-color: #ffffff;
        border-color: #86b7fe;
        outline: 0;
        box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.25);
    }
`;

const DropdownList = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    margin-top: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const DropdownItem = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    color: #000000;
    border-bottom: 1px solid #e9ecef;
    
    &:hover {
        background-color: #f8f9fa;
    }
    
    &:last-child {
        border-bottom: none;
    }
`;

const DropdownEmpty = styled.div`
    padding: 8px 12px;
    color: #6c757d;
    font-style: italic;
`;

function CreatePpvSpecificModale({ ppvGeneraleId, editData, arenasList, onArenasLoad, closeModalClick, onPpvSpecificCreated }) {
    const isEditMode = !!editData;
    const formRef = useRef(null);
    const dropdownRef = useRef(null);
    const [responseApiCreatePpv, setResponseApiCreatePpv] = useState({});
    const [errorsForm, setErrorsForm] = useState({});
    const [isLoadingForm, setIsLoadingForm] = useState(false);
    const [ppvCreated, setPpvCreated] = useState(false);
    const [isFirstRendering, setIsFirstRendering] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const [useDatePicker, setUseDatePicker] = useState(false);
    const [dateValue, setDateValue] = useState('');
    const [arenaSearch, setArenaSearch] = useState('');
    const [selectedArena, setSelectedArena] = useState(null);
    const [showArenaDropdown, setShowArenaDropdown] = useState(false);
    const [filteredArenas, setFilteredArenas] = useState([]);

    // Carica le arene se non sono disponibili
    useEffect(() => {
        if (!arenasList || arenasList.length === 0) {
            if (onArenasLoad) {
                onArenasLoad();
            }
        }
    }, [arenasList, onArenasLoad]);

    // Filtra le arene in base alla ricerca
    useEffect(() => {
        if (!arenasList || arenasList.length === 0) {
            setFilteredArenas([]);
            return;
        }

        if (!arenaSearch || arenaSearch.trim() === '') {
            setFilteredArenas(arenasList);
        } else {
            const searchLower = arenaSearch.toLowerCase();
            const filtered = arenasList.filter(arena => 
                arena.name.toLowerCase().includes(searchLower) ||
                (arena.city && arena.city.toLowerCase().includes(searchLower))
            );
            setFilteredArenas(filtered);
        }
    }, [arenaSearch, arenasList]);

    // Chiudi dropdown quando si clicca fuori
    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowArenaDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Funzione per convertire data in formato YYYY-MM-DD
    const convertDateToISO = (dateString: any) => {
        if (!dateString || dateString.trim() === '') return '';
        
        const trimmedDate = dateString.trim();
        
        // Se è già in formato YYYY-MM-DD, restituiscilo così
        if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedDate)) {
            return trimmedDate;
        }
        
        // Prova a parsare come Date object (gestisce molti formati)
        const dateObj = new Date(trimmedDate);
        
        // Verifica che la data sia valida
        if (!isNaN(dateObj.getTime())) {
            const year = dateObj.getFullYear();
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const day = String(dateObj.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
        
        // Se non è una data valida, prova con formato italiano
        const mesi = {
            'gennaio': 1, 'febbraio': 2, 'marzo': 3, 'aprile': 4, 'maggio': 5, 'giugno': 6,
            'luglio': 7, 'agosto': 8, 'settembre': 9, 'ottobre': 10, 'novembre': 11, 'dicembre': 12
        };
        
        // Prova a parsare formato italiano: "5 aprile 2026" o "05 aprile 2026"
        const regex = /(\d{1,2})\s+([a-z]+)\s+(\d{4})/i;
        const match = trimmedDate.match(regex);
        
        if (match) {
            const giorno = parseInt(match[1], 10);
            const meseNome = match[2].toLowerCase();
            const anno = parseInt(match[3], 10);
            
            if (mesi[meseNome] && giorno >= 1 && giorno <= 31 && anno >= 1900) {
                const mese = mesi[meseNome];
                // Formatta come YYYY-MM-DD
                return `${anno}-${String(mese).padStart(2, '0')}-${String(giorno).padStart(2, '0')}`;
            }
        }
        
        // Se non riesce a convertire, lancia un errore o restituisci stringa vuota
        console.warn('Formato data non riconosciuto:', dateString);
        return '';
    };

    const handleSubmit = async (event: any) => {
        setIsLoadingForm(true);
        setErrorsForm({});
        event.preventDefault();
        
        const formData = new FormData();
        formData.append('ppv_id', ppvGeneraleId);
        
        // Arena (nullable)
        if (selectedArena) {
            formData.append('arena_id', selectedArena.id);
        }
        
        // Data - converti sempre in formato YYYY-MM-DD
        let dateToSend = '';
        if (dateValue) {
            dateToSend = convertDateToISO(dateValue);
            if (!dateToSend) {
                setErrorsForm({ date: 'Formato data non valido. Usa formato YYYY-MM-DD o "giorno mese anno"' });
                setIsLoadingForm(false);
                return;
            }
        }
        formData.append('date', dateToSend);
        
        // Poster (file)
        if (selectedFile) {
            formData.append('poster', selectedFile);
        }
        
        // Night 1, 2, 3 (nullable)
        const night1 = formRef.current?.night1?.value?.trim() || '';
        const night2 = formRef.current?.night2?.value?.trim() || '';
        const night3 = formRef.current?.night3?.value?.trim() || '';
        
        if (night1) formData.append('night1', night1);
        if (night2) formData.append('night2', night2);
        if (night3) formData.append('night3', night3);

        try {
            let response;
            if (isEditMode && editData?.id) {
                response = await apiEditPpvSpecificV2(formData, editData.id);   
            } else {
                response = await apiCreatePpvSpecificV2(formData);
            }
            setResponseApiCreatePpv(response);
        } catch (error) {
            console.error('Errore durante la creazione/modifica del PPV specifico:', error);
            setIsLoadingForm(false);
        }
    };

    useEffect(() => {
        if (!isFirstRendering) {
            if (responseApiCreatePpv.errors) {
                setErrorsForm(responseApiCreatePpv.errors);
                setIsLoadingForm(false);
            } else if (Object.keys(responseApiCreatePpv).length > 0 && !responseApiCreatePpv.error && !ppvCreated) {
                setIsLoadingForm(false);
                setPpvCreated(true);
                // Chiama la callback per aggiornare la lista - solo una volta
                if (onPpvSpecificCreated) {
                    onPpvSpecificCreated();
                }
            }
        } else {
            setIsFirstRendering(false);
        }
    }, [responseApiCreatePpv]);

    const handleFileChange = (event: any) => {
        const file = event.target.files?.[0];
        if (file) {
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    const handleRemoveFile = () => {
        setSelectedFile(null);
        if (formRef.current) {
            const fileInput = formRef.current.querySelector('input[type="file"]');
            if (fileInput) {
                fileInput.value = '';
            }
        }
    };

    const handleCloseModal = () => {
        // Reset form quando si chiude la modale
        if (formRef.current) {
            formRef.current.reset();
        }
        setPpvCreated(false);
        setErrorsForm({});
        setSelectedFile(null);
        setDateValue('');
        setArenaSearch('');
        setSelectedArena(null);
        setShowArenaDropdown(false);
        closeModalClick();
    };

    const handleArenaSelect = (arena: any) => {
        setSelectedArena(arena);
        setArenaSearch(arena.name + (arena.city ? ` (${arena.city})` : ''));
        setShowArenaDropdown(false);
    };

    const handleClearArena = () => {
        setSelectedArena(null);
        setArenaSearch('');
    };

    const handleDateInputChange = (e: any) => {
        setDateValue(e.target.value);
    };

    const toggleDateInput = () => {
        setUseDatePicker(!useDatePicker);
        if (!editData) {
            setDateValue('');
        }
    };

    // Reset form quando cambiano i dati di modifica o quando si apre la modale
    useEffect(() => {
        if (editData) {
            // Precompila i campi quando si apre in modalità modifica
            // Data
            if (editData.date) {
                // Gestisci sia timestamp che stringhe
                let date;
                if (typeof editData.date === 'number') {
                    date = editData.date > 1e12 ? new Date(editData.date) : new Date(editData.date * 1000);
                } else if (typeof editData.date === 'string') {
                    // Se è una stringa, prova a parsarla
                    if (/^\d+$/.test(editData.date)) {
                        const numValue = parseInt(editData.date);
                        date = numValue > 1e12 ? new Date(numValue) : new Date(numValue * 1000);
                    } else {
                        date = new Date(editData.date);
                    }
                } else {
                    date = new Date(editData.date);
                }
                
                if (!isNaN(date.getTime())) {
                    // Formatta come YYYY-MM-DD per il date picker
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    setDateValue(`${year}-${month}-${day}`);
                    setUseDatePicker(true);
                }
            }
            
            // Arena - aspetta che le arene siano caricate
            if (editData.arena_id) {
                if (arenasList && arenasList.length > 0) {
                    const arena = arenasList.find(a => a.id === editData.arena_id);
                    if (arena) {
                        setSelectedArena(arena);
                        setArenaSearch(arena.name + (arena.city ? ` (${arena.city})` : ''));
                    }
                } else if (onArenasLoad) {
                    // Se le arene non sono caricate, caricale
                    onArenasLoad();
                }
            }
        } else {
            // Reset form quando si crea un nuovo PPV
            setDateValue('');
            setArenaSearch('');
            setSelectedArena(null);
            setUseDatePicker(false);
            if (formRef.current) {
                formRef.current.reset();
            }
        }
        // Reset del file selezionato quando cambiano i dati
        setSelectedFile(null);
    }, [editData, arenasList, onArenasLoad]);

    return (
        <Container className="create-ppv-specific-modale-container">
            <ModalDialog className="create-ppv-specific-modale-dialog">
                <ModalContent isDropdownOpen={showArenaDropdown} className="create-ppv-specific-modale-content">
                    <form ref={formRef} onSubmit={handleSubmit} encType="multipart/form-data" className="create-ppv-specific-modale-form">
                        <ModalHeader className="create-ppv-specific-modale-header">
                            <ModalHeaderTop className="create-ppv-specific-modale-header-top">
                                <ModalTitle className="create-ppv-specific-modale-title">
                                    {isEditMode ? 'Modifica PPV Specifico' : 'Aggiungi PPV Specifico'}
                                </ModalTitle>
                                <CloseButton type="button" aria-label="Close" onClick={handleCloseModal} className="create-ppv-specific-modale-close-button"></CloseButton>
                            </ModalHeaderTop>
                        </ModalHeader>
                        <ModalBody className="create-ppv-specific-modale-body">
                            <FormGroup className="create-ppv-specific-modale-form-group">
                                <FormLabel htmlFor="date" className="create-ppv-specific-modale-label">Data *</FormLabel>
                                <DateInputContainer>
                                    {useDatePicker ? (
                                        <FormInput 
                                            type="date" 
                                            id="date" 
                                            name="date" 
                                            required 
                                            className="create-ppv-specific-modale-input"
                                            value={dateValue}
                                            onChange={handleDateInputChange}
                                        />
                                    ) : (
                                        <FormInput 
                                            type="text" 
                                            id="date" 
                                            name="date" 
                                            required 
                                            className="create-ppv-specific-modale-input"
                                            placeholder="Formato: giorno mese anno (es: 5 aprile 2026) oppure YYYY-MM-DD"
                                            value={dateValue}
                                            onChange={handleDateInputChange}
                                        />
                                    )}
                                    <DateToggleButton type="button" onClick={toggleDateInput}>
                                        {useDatePicker ? 'Input Manuale' : 'Calendario'}
                                    </DateToggleButton>
                                </DateInputContainer>
                                {errorsForm.date && <ErrorText className="create-ppv-specific-modale-error-text">{Array.isArray(errorsForm.date) ? errorsForm.date[0] : errorsForm.date}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-specific-modale-form-group">
                                <FormLabel htmlFor="poster" className="create-ppv-specific-modale-label">
                                    Poster
                                    {isEditMode && (
                                        <FileInfoText style={{ marginTop: '4px', marginBottom: '0', fontSize: '12px', color: 'rgba(255, 255, 255, 0.6)', fontStyle: 'italic' }}>
                                            (Se non vuoi modificare il poster, non selezionare nessun file)
                                        </FileInfoText>
                                    )}
                                </FormLabel>
                                <FormInput 
                                    type="file" 
                                    id="poster" 
                                    name="poster" 
                                    accept="image/*" 
                                    className="create-ppv-specific-modale-input"
                                    onChange={handleFileChange}
                                />
                                {editData?.img_path && !selectedFile && (
                                    <FileInfoText style={{ marginTop: '8px', fontSize: '12px', color: 'rgba(255, 255, 255, 0.6)', fontStyle: 'italic' }}>
                                        Poster attuale: {editData.img_path}
                                    </FileInfoText>
                                )}
                                {selectedFile && (
                                    <FileSelectedContainer className="create-ppv-specific-modale-file-selected-container">
                                        <FileSelectedText className="create-ppv-specific-modale-file-selected-text">
                                            File selezionato: {selectedFile.name}
                                        </FileSelectedText>
                                        <RemoveFileButton 
                                            type="button"
                                            onClick={handleRemoveFile}
                                            className="create-ppv-specific-modale-remove-file-button"
                                        >
                                            Rimuovi
                                        </RemoveFileButton>
                                    </FileSelectedContainer>
                                )}
                                {errorsForm.poster && <ErrorText className="create-ppv-specific-modale-error-text">{Array.isArray(errorsForm.poster) ? errorsForm.poster[0] : errorsForm.poster}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-specific-modale-form-group">
                                <FormLabel htmlFor="arena" className="create-ppv-specific-modale-label">Arena (opzionale)</FormLabel>
                                <DropdownContainer ref={dropdownRef}>
                                    <DropdownInput
                                        type="text"
                                        id="arena"
                                        name="arena"
                                        placeholder="Cerca arena..."
                                        value={arenaSearch}
                                        onChange={(e: any) => {
                                            setArenaSearch(e.target.value);
                                            setShowArenaDropdown(true);
                                        }}
                                        onFocus={() => setShowArenaDropdown(true)}
                                    />
                                    {selectedArena && (
                                        <RemoveFileButton 
                                            type="button"
                                            onClick={handleClearArena}
                                            style={{ marginTop: '8px' }}
                                        >
                                            Rimuovi Arena
                                        </RemoveFileButton>
                                    )}
                                    {showArenaDropdown && filteredArenas.length > 0 && (
                                        <DropdownList>
                                            {filteredArenas.map((arena: any) => (
                                                <DropdownItem 
                                                    key={arena.id}
                                                    onClick={() => handleArenaSelect(arena)}
                                                >
                                                    {arena.name} {arena.city ? `(${arena.city})` : ''}
                                                </DropdownItem>
                                            ))}
                                        </DropdownList>
                                    )}
                                    {showArenaDropdown && filteredArenas.length === 0 && arenasList && arenasList.length > 0 && (
                                        <DropdownList>
                                            <DropdownEmpty>Nessuna arena trovata</DropdownEmpty>
                                        </DropdownList>
                                    )}
                                    {showArenaDropdown && (!arenasList || arenasList.length === 0) && (
                                        <DropdownList>
                                            <DropdownEmpty>Caricamento arene...</DropdownEmpty>
                                        </DropdownList>
                                    )}
                                </DropdownContainer>
                                {errorsForm.arena_id && <ErrorText className="create-ppv-specific-modale-error-text">{Array.isArray(errorsForm.arena_id) ? errorsForm.arena_id[0] : errorsForm.arena_id}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-specific-modale-form-group">
                                <FormLabel htmlFor="night1" className="create-ppv-specific-modale-label">Night 1 (URL)</FormLabel>
                                <FormInput 
                                    type="text" 
                                    id="night1" 
                                    name="night1" 
                                    className="create-ppv-specific-modale-input"
                                    placeholder="Inserisci URL per Night 1 (opzionale)"
                                    defaultValue={editData?.night1 || ''}
                                />
                                {errorsForm.night1 && <ErrorText className="create-ppv-specific-modale-error-text">{Array.isArray(errorsForm.night1) ? errorsForm.night1[0] : errorsForm.night1}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-specific-modale-form-group">
                                <FormLabel htmlFor="night2" className="create-ppv-specific-modale-label">Night 2 (URL)</FormLabel>
                                <FormInput 
                                    type="text" 
                                    id="night2" 
                                    name="night2" 
                                    className="create-ppv-specific-modale-input"
                                    placeholder="Inserisci URL per Night 2 (opzionale)"
                                    defaultValue={editData?.night2 || ''}
                                />
                                {errorsForm.night2 && <ErrorText className="create-ppv-specific-modale-error-text">{Array.isArray(errorsForm.night2) ? errorsForm.night2[0] : errorsForm.night2}</ErrorText>}
                            </FormGroup>

                            <FormGroup className="create-ppv-specific-modale-form-group">
                                <FormLabel htmlFor="night3" className="create-ppv-specific-modale-label">Night 3 (URL)</FormLabel>
                                <FormInput 
                                    type="text" 
                                    id="night3" 
                                    name="night3" 
                                    className="create-ppv-specific-modale-input"
                                    placeholder="Inserisci URL per Night 3 (opzionale)"
                                    defaultValue={editData?.night3 || ''}
                                />
                                {errorsForm.night3 && <ErrorText className="create-ppv-specific-modale-error-text">{Array.isArray(errorsForm.night3) ? errorsForm.night3[0] : errorsForm.night3}</ErrorText>}
                            </FormGroup>
                        </ModalBody>
                        <ModalFooter className="create-ppv-specific-modale-footer">
                            <ButtonSecondary type="button" onClick={handleCloseModal} className="create-ppv-specific-modale-button-secondary">Chiudi</ButtonSecondary>
                            <ButtonPrimary type="submit" disabled={isLoadingForm || ppvCreated} className="create-ppv-specific-modale-button-primary">
                                {isLoadingForm ? 'Caricamento...' : (isEditMode ? 'Modifica PPV Specifico' : 'Crea PPV Specifico')}
                            </ButtonPrimary>
                        </ModalFooter>
                        {isLoadingForm && <StatusMessage className="create-ppv-specific-modale-status-message">Caricamento..</StatusMessage>}
                        {ppvCreated && <SuccessText className="create-ppv-specific-modale-success-text">
                            {isEditMode ? 'PPV specifico modificato con successo!' : 'PPV specifico creato con successo!'}
                        </SuccessText>}
                    </form>
                </ModalContent>
            </ModalDialog>
        </Container>
    );
}

export default CreatePpvSpecificModale;
